export type Platform = {
  id: string;
  name: string;
  type: string;
  region: string;
  note: string;
  url: string;
};

export type GuideArticle = {
  id: string;
  title: string;
  summary: string;
  content: string[];
  publishDate: string;
  tags: string[];
  relatedEpisodeId?: string;
  relatedCharacterId?: string;
};

export type Faq = {
  id: string;
  question: string;
  answer: string;
};

export const platforms: Platform[] = [
  {
    id: "plat-01",
    name: "哔哩哔哩动画",
    type: "正版授权平台",
    region: "中国大陆",
    note: "官方授权播出，支持正版弹幕与追番。",
    url: "https://www.bilibili.com/",
  },
  {
    id: "plat-02",
    name: "腾讯视频动漫",
    type: "正版授权平台",
    region: "中国大陆",
    note: "部分季度同步更新，可开通会员观看高清版本。",
    url: "https://v.qq.com/",
  },
  {
    id: "plat-03",
    name: "爱奇艺动漫",
    type: "正版授权平台",
    region: "中国大陆",
    note: "提供官方字幕与多语言版本选择。",
    url: "https://www.iqiyi.com/",
  },
  {
    id: "plat-04",
    name: "Crunchyroll",
    type: "海外正版平台",
    region: "海外",
    note: "面向海外观众，含英文字幕与配音版本。",
    url: "https://www.crunchyroll.com/",
  },
];

export const guideArticles: GuideArticle[] = [
  {
    id: "art-01",
    title: "《甜蜜惩罚》结局解析：'甜蜜'与'惩罚'究竟指什么？",
    summary:
      "第十一集与第十二集标题里的'甜蜜惩罚'一直是观众热议的焦点。本文从招牌、书签与雨夜三个意象出发，拆解结局真正的含义。",
    content: [
      "'甜蜜惩罚'这个标题乍看矛盾，其实是全剧最核心的一组对立：甜的是重逢与和解，惩罚的是那些被沉默浪费掉的年头。",
      "第一个意象是甜品店的招牌。第十二集里，苏晚把店名改成'甜蜜惩罚'，等于亲手把这段关系的全部代价写在了门上——她接受了甜，也接受了曾经的苦。",
      "第二个意象是那枚手写书签。它从第一集出现，到第九集在异乡书店再次出现，承担了'把没说出口的话留住'的功能。书签的每一次现身，都对应一次关系的转机。",
      "第三个意象是雨。全剧的雨夜几乎都发生在两个关键节点：初遇与告白。导演用同一场雨把开始和重新开始缝在一起，让结局呼应了开场。",
      "所以结局并不只是一个团圆，它更像一句和解：两个人终于学会在雨里，把话说完。",
    ],
    publishDate: "2025-06-24",
    tags: ["结局解析", "主题", "深度"],
    relatedEpisodeId: "ep-12",
  },
  {
    id: "art-02",
    title: "为什么顾时衍总在关键时刻沉默？他的三次'没说出口'",
    summary:
      "从书店的假装不认识，到发布会上的当众沉默，顾时衍的每一次欲言又止都推动了剧情走向。本文复盘他的三次关键沉默。",
    content: [
      "顾时衍这个角色最大的特点，是把表达变成了需要练习的事。他的成长弧线，其实就是'从沉默到开口'的过程。",
      "第一次沉默发生在第二集。他在甜品店装作不认识苏晚，看似冷淡，实则是不知道该如何面对一个让自己破例的人。",
      "第二次沉默发生在第八集。发布会上的默不作声，是全剧最大的误会来源，也是两人关系最低谷的起点。他为了保护苏晚不受更大的牵连，选择了看似伤害她的方式。",
      "第三次'沉默'发生在第十一集，但性质完全不同——他把信和书签交出去，却把决定权留给了苏晚。这一次的沉默，是尊重，而不是逃避。",
      "三次沉默，一次比一次成熟，这正是编剧对'怎样才算爱一个人'的回答。",
    ],
    publishDate: "2025-06-20",
    tags: ["角色分析", "剧情梳理"],
    relatedCharacterId: "gu-shiyan",
  },
  {
    id: "art-03",
    title: "观看顺序指南：第一次看《甜蜜惩罚》该怎么追？",
    summary:
      "按播出顺序看最省心，但如果你想体会双线叙事的乐趣，可以试试本文推荐的两种观看路径。",
    content: [
      "标准路径：从第一集到第十二集按顺序观看。全剧节奏前松后紧，前四集铺陈日常，第五集后进入主线，适合第一次接触的观众。",
      "主题路径：先看第六集（告白）与第九集（重逢），再回看中间的四集。这样能更快抓住人物关系的核心，也更容易理解后面的误会。",
      "无论选择哪一种，都建议在看完第十二集后重看第一集。开场那个雨夜在结局的对照下会呈现出完全不同的味道。",
    ],
    publishDate: "2025-06-18",
    tags: ["观看指南", "入门"],
    relatedEpisodeId: "ep-01",
  },
  {
    id: "art-04",
    title: "三个细节看懂《甜蜜惩罚》的配色语言",
    summary:
      "橙红、奶油白与雨灰贯穿全剧，颜色其实是导演在替角色说话。本文带你读懂这部剧的色彩叙事。",
    content: [
      "橙红出现在两人距离拉近的所有场景：甜品店的暖光、告白时的霓虹、结局的招牌。它是'靠近'的信号。",
      "奶油白对应苏晚的视角，出现在她独处、读书与写作的场景里，代表她身上那种尚未被现实磨平的干净。",
      "雨灰则是顾时衍的底色，出现在所有他选择沉默的镜头里，冷、克制，却又有着被雨洗过后的通透。",
      "当第十二集三种颜色同时出现在一个画面里时，就是导演给观众的最后一句台词。",
    ],
    publishDate: "2025-06-15",
    tags: ["视觉", "深度", "细节"],
    relatedEpisodeId: "ep-03",
  },
  {
    id: "art-05",
    title: "配角也很重要：林小满与陈默如何推动主线",
    summary:
      "很多观众会觉得配角只是点缀，但在《甜蜜惩罚》里，正是两个配角各自的一个动作，改变了主线走向。",
    content: [
      "林小满的作用是'破冰'。她在第四集无意间提到顾时衍的中学往事，才让苏晚意识到眼前的少年并不是完全陌生的人。",
      "陈默的作用是'补全'。他在第七集向苏晚讲述顾家的变故，把观众和女主同时推向了理解男主的那一侧。",
      "两个配角都没有抢戏，却各自在关键节点完成了一次信息传递。这种克制，正是这部剧叙事上的成熟之处。",
    ],
    publishDate: "2025-06-12",
    tags: ["角色分析", "配角"],
    relatedCharacterId: "lin-xiaoman",
  },
];

export const faqs: Faq[] = [
  {
    id: "faq-01",
    question: "本站可以直接在线观看吗？",
    answer:
      "不能。本站是纯内容介绍与攻略网站，不提供任何播放、下载功能。想看正片，请前往观看指南中列出的正版授权平台。",
  },
  {
    id: "faq-02",
    question: "收藏功能需要登录吗？",
    answer:
      "不需要。收藏仅保存在你自己的浏览器本地，换设备或清除浏览器数据后会消失，我们不会收集任何个人信息。",
  },
  {
    id: "faq-03",
    question: "剧情介绍和角色档案的信息从哪里来？",
    answer:
      "全部内容来自本站编辑整理的演示资料，用于展示网站结构与内容组织方式，具体以官方发布信息为准。",
  },
  {
    id: "faq-04",
    question: "为什么搜索不到某个角色？",
    answer:
      "可以先试试角色名的关键字，或前往角色介绍页按主角 / 配角 / 反派分类浏览。目前收录的是主要角色档案。",
  },
];

export const guideContact = {
  email: "hello@sweet-punishment-anime.example.com",
  social: "@sweetpunishment_anime",
};